<template>
	<div class="no-matches">
		<div class="no-matches--left">
			<Jon white/>
		</div>
		<div class="no-matches--right">
			<div class="no-matches--title" v-html="title"/>
			<div class="no-matches--content">
				<slot/>
			</div>
		</div>
	</div>
</template>

<script>
import Jon from "@/vue/common/image/Jon.vue";

export default {
	components: {Jon},

	props: {
		title: {
			type: String,
			required: true,
		}
	}
}
</script>
